import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import DataAssetLoader from "utilities/suits/data-asset-loader/2.0.3/js/data-asset-loader";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.0.2/js/sparta-transport-utility";
























const STRINGS = {
  UNITED_STATES: 'US',
  CANADA: 'CANADA',
  INTERNATIONAL: 'INTERNATIONAL',
  ENGLISH_LANGUAGE: 'en',
  SPANISH_LANGUAGE: 'es',
  GWIM: 'GWIM',
  US_TRUST: 'US TRUST',
  CED: 'CED',
  ISO2: 'ISO-2',
  ISO3: 'ISO-3',
  ISO3166: 'ISO-3166',
  CONTAINS: 'Contains',
  EXACT_MATCH: 'Exact Match',
  CITY_COUNTY_EN: 'Start with a letter and follow with only letters, spaces, periods (.) and hyphens (-).',
  CITY_COUNTY_ES: 'Comience con una letra y siga solo con letras, espacios, puntos (.) y guiones (-).',
};

class AMLValidationRules {
  init(validator, validationRulesImporter) {
    const self = this;

    this.language = spartaStoreUtility.getData('lang').split('-')[0];
    this.importer = validationRulesImporter;
    this.validator = validator;





    const AML = {




















      firstName($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.firstName',
          keyName: 'name',

          maxLength: 40,
          maxRepeatedChar: ["a-zA-Z0-9 '.-", 2],
          maxRepeatExceptions: ['VIII', 'VIII.'],
          allowSpecialChars: true,
        };

        let options = {
          maxLength: defaults.maxLength,
          allowSpecialChars: defaults.allowSpecialChars,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {

          nameCharacters: [options.allowSpecialChars],
          maxLength: [options.maxLength],
        };

        let validRepeatException = false;

        options.maxRepeatExceptions.every((value) => {
          const validException = $element.val().toUpperCase() === value;

          if (validException) {
            validRepeatException = true;

            return false;
          }

          return true;
        });

        if (!validRepeatException) {
          validations.maxRepeatedChar = options.maxRepeatedChar;
        }

        const validationsResult = self.getValidationResults($element, validations);
        const invalidListResult = self.getInvalidResults($element, options.ruleName,
          options.keyName);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (invalidListResult instanceof Object) {
          return invalidListResult;
        }

        if (validationsResult && !invalidListResult) {
          return true;
        }

        return false;
      },





















      middleName($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.middleName',
          keyName: 'name',

          maxLength: 40,
          maxRepeatedChar: ["a-zA-Z0-9 '.-", 2],
          maxRepeatExceptions: ['VIII', 'VIII.'],
          allowSpecialChars: true,
        };

        let options = {
          maxLength: defaults.maxLength,
          allowSpecialChars: defaults.allowSpecialChars,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {

          nameCharacters: [options.allowSpecialChars],
          maxLength: [options.maxLength],
        };

        let validRepeatException = false;

        options.maxRepeatExceptions.every((value) => {
          const validException = $element.val().toUpperCase() === value;

          if (validException) {
            validRepeatException = true;

            return false;
          }

          return true;
        });

        if (!validRepeatException) {
          validations.maxRepeatedChar = options.maxRepeatedChar;
        }

        const validationsResult = self.getValidationResults($element, validations);
        const invalidListResult = self.getInvalidResults($element, options.ruleName,
          options.keyName);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (invalidListResult instanceof Object) {
          return invalidListResult;
        }

        if (validationsResult && !invalidListResult) {
          return true;
        }

        return false;
      },





















      lastName($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.lastName',
          keyName: 'name',
          minLength: 2,
          maxLength: 40,
          maxRepeatedChar: ["a-zA-Z0-9 '.-", 2],
          allowSpecialChars: true,
        };

        let options = {
          maxLength: defaults.maxLength,
          allowSpecialChars: defaults.allowSpecialChars,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          minLength: [options.minLength],
          nameCharacters: [options.allowSpecialChars],
          maxRepeatedChar: options.maxRepeatedChar,
          maxLength: [options.maxLength],
        };

        const validationsResult = self.getValidationResults($element, validations);
        const invalidListResult = self.getInvalidResults(
          $element,
          options.ruleName,
          options.keyName
        );

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (invalidListResult instanceof Object) {
          return invalidListResult;
        }

        if (validationsResult && !invalidListResult) {
          return true;
        }

        return false;
      },














      namePrefix($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.namePrefix',
          keyName: 'code',
        };

        const options = Object.assign({}, defaults);

        const validations = {
          namePrefix: [],
        };


        $element.val($element.val().toUpperCase());

        const validationsResult = self.getValidationResults($element, validations);
        const validListResult = self.getValidResults($element, options.ruleName, options.keyName);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validListResult instanceof Object) {
          return validListResult;
        }

        if (validationsResult && validListResult) {
          return true;
        }

        return false;
      },














      nameSuffix($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.nameSuffix',
          keyName: 'code',
        };

        const options = Object.assign({}, defaults);

        const validations = {
          nameSuffix: [],
        };


        $element.val($element.val().toUpperCase());

        const validationsResult = self.getValidationResults($element, validations);
        const validListResult = self.getValidResults($element, options.ruleName, options.keyName);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validListResult instanceof Object) {
          return validListResult;
        }

        if (validationsResult && validListResult) {
          return true;
        }

        return false;
      },














      nameGeneration($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.nameGeneration',
          keyName: 'code',
        };

        const options = Object.assign({}, defaults);

        const validations = {
          nameGeneration: [],
        };


        $element.val($element.val().toUpperCase());

        const validationsResult = self.getValidationResults($element, validations);
        const validListResult = self.getValidResults($element, options.ruleName, options.keyName);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validListResult instanceof Object) {
          return validListResult;
        }

        if (validationsResult && validListResult) {
          return true;
        }

        return false;
      },


















      businessName($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.businessName',
          keyName: 'name',
          minLength: 3,
          maxLength: 60,
        };

        let options = {
          maxLength: defaults.maxLength,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          minLength: [options.minLength],
          maxLength: [options.maxLength],
        };

        const validationsResult = self.getValidationResults($element, validations);
        const invalidListResult = self.getInvalidResults(
          $element,
          options.ruleName,
          options.keyName
        );

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (invalidListResult instanceof Object) {
          return invalidListResult;
        }

        if (validationsResult && !invalidListResult) {
          return true;
        }

        return false;
      },

























      addressLine1($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.addressLine1',
          keyName: 'address',
          validSpecialChars: "#/.,'-",
          isMailingAddress: true,
          minLength: 3,
          maxLength: 30,
        };

        let options = {
          maxLength: defaults.maxLength,
          validSpecialChars: defaults.validSpecialChars,
          isMailingAddress: defaults.isMailingAddress,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          minLength: [options.minLength],
          intlStreetAddress: [options.validSpecialChars, options.isMailingAddress],
          maxLength: [options.maxLength],
        };

        const validationsResult = self.getValidationResults($element, validations);
        const invalidListResult = self.getInvalidResults($element, options.ruleName, options.keyName);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (invalidListResult instanceof Object) {
          return invalidListResult;
        }

        if (validationsResult && !invalidListResult) {
          return true;
        }

        return false;
      },

























      addressLine2($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.addressLine2',
          keyName: 'address',
          validSpecialChars: "#/.,'-",
          isMailingAddress: true,
          minLength: 3,
          maxLength: 30,
        };

        let options = {
          maxLength: defaults.maxLength,
          validSpecialChars: defaults.validSpecialChars,
          isMailingAddress: defaults.isMailingAddress,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          minLength: [options.minLength],
          intlStreetAddress: [options.validSpecialChars, options.isMailingAddress],
          maxLength: [options.maxLength],
        };

        const validationsResult = self.getValidationResults($element, validations);
        const invalidListResult = self.getInvalidResults($element, options.ruleName, options.keyName);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (invalidListResult instanceof Object) {
          return invalidListResult;
        }

        if (validationsResult && !invalidListResult) {
          return true;
        }

        return false;
      },





















      cityCounty($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.cityCounty',
          keyName: 'city',
          minLength: 3,
          maxLength: 19,
          region: STRINGS.UNITED_STATES,
          validCharacters: null,
        };

        let options = {
          region: defaults.region,
          minLength: defaults.minLength,
          validCharacters: defaults.validCharacters,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        if (options.region === STRINGS.UNITED_STATES && !options.validCharacters) {
          options.validCharacters = '.-';
        }

        const validations = {
          minLength: [options.minLength],
          cityCounty: [options.region, options.validCharacters],
          maxLength: [options.maxLength],
        };

        if (options.region.toUpperCase() !== STRINGS.UNITED_STATES) {
          validations.minLength = [2];
        }

        const validationsResult = self.getValidationResults($element, validations);
        const invalidListResult = self.getInvalidResults($element, options.ruleName, options.keyName);

        if (validationsResult instanceof Object) {
          let result = {};

          if (options.region.toUpperCase() === STRINGS.UNITED_STATES && self.language === STRINGS.ENGLISH_LANGUAGE) {
            result.errorMessage = STRINGS.CITY_COUNTY_EN;
          } else if (options.region.toUpperCase() === STRINGS.UNITED_STATES && self.language === STRINGS.SPANISH_LANGUAGE) {
            result.errorMessage = STRINGS.CITY_COUNTY_ES;
          }

          result = Object.assign({}, validationsResult, result);

          return result;
        }

        if (invalidListResult instanceof Object) {
          return invalidListResult;
        }

        if (validationsResult && !invalidListResult) {
          return true;
        }

        return false;
      },


















      stateCode($element, ruleParams) {
        let validListResult = false;

        const defaults = {
          ruleName: 'AML.stateCode',
          keyName: 'code',
          minLength: 2,
          maxLength: 2,
          region: STRINGS.UNITED_STATES,
        };

        let options = {
          region: defaults.region,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          minLength: [options.minLength],
          stateCode: [options.region],
          maxLength: [options.maxLength],
        };


        $element.val($element.val().toUpperCase());

        if (options.region === STRINGS.UNITED_STATES) {
          validListResult = self.getValidResults($element, options.ruleName, options.keyName);
        }

        if (options.region === STRINGS.CANADA) {
          validations.stateCode = [STRINGS.CANADA];
          validListResult = true;
        }

        if (options.region === STRINGS.INTERNATIONAL) {
          validations.stateCode = [STRINGS.INTERNATIONAL];
          validations.maxLength = [5];
          validListResult = true;
        }

        const validationsResult = self.getValidationResults($element, validations);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validListResult instanceof Object) {
          return validListResult;
        }

        if (validationsResult && validListResult) {
          return true;
        }

        return false;
      },





















      zipCode($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.zipCode',
          minLength: 5,
          maxLength: 5,
          region: STRINGS.UNITED_STATES,
          exceptionRule: STRINGS.GWIM,
          gwimExceptions: ['44444', '12345'],
          invalidZipCodes: ['00000', '11111', '22222', '33333', '55555', '66666',
            '77777', '88888', '99999', '54321'],
        };

        let options = {
          region: defaults.region,
          exceptionRule: defaults.exceptionRule,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        if (options.exceptionRule.toUpperCase() !== STRINGS.GWIM) {
          options.invalidZipCodes = options.invalidZipCodes.concat(options.gwimExceptions);
        }

        let validations = {
          minLength: [options.minLength],
          zip: [options.region],
          isNotValue: [options.invalidZipCodes],
          maxLength: [options.maxLength],
        };

        if (options.region.toUpperCase() !== STRINGS.UNITED_STATES) {
          validations = {
            minLength: [3],
            maxLength: [7],
          };


          $element.val($element.val().toUpperCase());

          if (options.region.toUpperCase() === STRINGS.INTERNATIONAL) {
            validations.maxLength = [10];
          }
        }

        const validationsResult = self.getValidationResults($element, validations);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validationsResult) {
          return true;
        }

        return false;
      },


















      countryCode($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.countryCode',
          minLength: 2,
          maxLength: 2,
          isoFormat: STRINGS.ISO2,
        };

        let options = {
          isoFormat: defaults.isoFormat,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          minLength: [options.minLength],
          countryCode: [options.isoFormat],
          maxLength: [options.maxLength],
        };


        $element.val($element.val().toUpperCase());

        if (options.isoFormat.toUpperCase() !== STRINGS.ISO2) {
          validations.maxLength = [3];

          if (options.isoFormat.toUpperCase() === STRINGS.ISO3166) {
            validations.minLength = [1];
          }
        }

        const validListResult = self.getValidResults($element, options.ruleName, options.isoFormat);

        const validationsResult = self.getValidationResults($element, validations);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validListResult instanceof Object) {
          return validListResult;
        }

        if (validationsResult && validListResult) {
          return true;
        }

        return false;
      },






















      dateOfBirth($dateElement, ruleParams) {
        const defaults = {
          ruleName: 'AML.dateOfBirth',
          dateType: 'fullDate',
          rangeException: false,
          minDateRange: '-125y',
          maxDateRange: '0d',
        };

        let options = {
          dateType: defaults.dateType,
          rangeException: defaults.rangeException,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        let validations = {
          dateFormat: [options.dateType],
          dateRange: [options.minDateRange, options.maxDateRange, options.dateType],
        };


        if (options.rangeException === true) {
          validations = {
            dateFormat: [options.dateType],
            endDate: [options.maxDateRange, options.dateType],
          };
        }

        const validationsResult = self.getValidationResults($dateElement, validations);

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validationsResult) {
          return true;
        }

        return false;
      },

















      ssn($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.ssn',
          allowExceptions: false,
          invalidSSNExceptions: [/^000000000$/],
          invalidSSNPatterns: [
            /^300000000$/,
            /^666(\d{2})(\d{4})$/,
            /^000(\d{2})([1-9]\d{3})$/,
            /^000([1-9]\d{1})(\d{4})$/,
            /^(\d{3})00([1-9]\d{3})$/,
            /^([1-9]\d{2})00(\d{4})$/,
            /^(\d{3})([1-9]\d{1})0000$/,
            /^([1-9]\d{2})(\d{2})0000$/,
            /^9(\d{2})89(\d{4})$/,
            /^9(\d{2})[0-6](\d{1})(\d{4})$/,
          ],
        };

        let options = {
          allowExceptions: defaults.allowExceptions,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          ssn: [],
        };

        const validationsResult = self.getValidationResults($element, validations);
        const elementValue = $element.val().replace(/\D/g, '');

        let invalidSSNResult = false;

        if (!options.allowExceptions) {
          options.invalidSSNPatterns =
            options.invalidSSNPatterns.concat(options.invalidSSNExceptions);
        }

        if (options.invalidSSNPatterns.length !== 0) {
          options.invalidSSNPatterns.every((invalidSSNPattern) => {
            invalidSSNResult = invalidSSNPattern.test(elementValue);

            if (invalidSSNResult) {
              return false;
            }

            return true;
          });
        }

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validationsResult && !invalidSSNResult) {
          return true;
        }

        return false;
      },

















      tin($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.tin',
          allowExceptions: false,
          invalidTINExceptions: [/^000000000$/],
          invalidTINPatterns: [
            /^300000000$/,
            /^400000000$/,
            /^500000000$/,
            /^000(\d{2})([1-9]\d{3})$/,
            /^000([1-9]\d{1})(\d{4})$/,
            /^(\d{3})00([1-9]\d{3})$/,
            /^([1-9]\d{2})00(\d{4})$/,
            /^(\d{3})([1-9]\d{1})0000$/,
            /^([1-9]\d{2})(\d{2})0000$/,
            /^9(\d{2})93(\d{4})$/,
            /^9(\d{2})[7|8|9](\d{1})(\d{4})$/,
          ],
        };

        let options = {
          allowExceptions: defaults.allowExceptions,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          ssn: [],
        };

        const validationsResult = self.getValidationResults($element, validations);
        const elementValue = $element.val().replace(/\D/g, '');

        let invalidTINResult = false;

        if (!options.allowExceptions) {
          options.invalidTINPatterns =
            options.invalidTINPatterns.concat(options.invalidTINExceptions);
        }

        if (options.invalidTINPatterns.length !== 0) {
          options.invalidTINPatterns.every((invalidTINPattern) => {
            invalidTINResult = invalidTINPattern.test(elementValue);

            if (invalidTINResult) {
              return false;
            }

            return true;
          });
        }

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validationsResult && !invalidTINResult) {
          return true;
        }

        return false;
      },

















      itin($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.itin',
          allowExceptions: false,
          validITINExceptions: [/^000000000$/],
          validITINPatterns: [
            /^9(\d{2})([7][0-9]|[8][0-8]|[9][0-2,4-9])(\d{4})$/,
          ],
        };

        let options = {
          allowExceptions: defaults.allowExceptions,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          ssn: [],
        };

        const validationsResult = self.getValidationResults($element, validations);

        const elementValue = $element.val().replace(/\D/g, '');

        let validITINResult = false;

        if (options.allowExceptions === true) {
          options.validITINExceptions.every((validITINException) => {
            validITINResult = validITINException.test(elementValue);

            if (validITINResult) {
              return false;
            }

            return true;
          });
        }

        if (!validITINResult && options.validITINPatterns.length !== 0) {
          options.validITINPatterns.every((validITINPattern) => {
            validITINResult = validITINPattern.test(elementValue);

            if (validITINResult) {
              return false;
            }

            return true;
          });
        }

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validationsResult && validITINResult) {
          return true;
        }

        return false;
      },

















      ein($element, ruleParams) {
        const defaults = {
          ruleName: 'AML.ein',
          allowExceptions: false,
          invalidEINExceptions: [/^000000000$/],
          invalidEINPatterns: [],
        };

        let options = {
          allowExceptions: defaults.allowExceptions,
        };

        options = validator.fn.helper.getDefinedParams(ruleParams, options);
        options = Object.assign({}, defaults, options);

        const validations = {
          ein: [],
        };

        const validationsResult = self.getValidationResults($element, validations);

        const elementValue = $element.val().replace(/\D/g, '');

        let invalidEINResult = false;

        if (!options.allowExceptions) {
          options.invalidEINPatterns =
            options.invalidEINPatterns.concat(options.invalidEINExceptions);
        }

        if (options.invalidEINPatterns.length !== 0) {
          options.invalidEINPatterns.every((invalidEINPattern) => {
            invalidEINResult = invalidEINPattern.test(elementValue);

            if (invalidEINResult) {
              return false;
            }

            return true;
          });
        }

        if (validationsResult instanceof Object) {
          return validationsResult;
        }

        if (validationsResult && !invalidEINResult) {
          return true;
        }

        return false;
      },
    };

    return AML;
  }









  getValidationResults($element, validations) {
    let validationResult = true;

    Object.keys(validations).every((ruleName) => {
      const ruleParams = validations[ruleName];

      validationResult = this.validator.fn.validate[ruleName]($element, ruleParams);

      if (!validationResult) {
        validationResult = { ruleName, ruleParams };

        return false;
      }

      return true;
    });

    return validationResult;
  }









  getInvalidResults($element, ruleName, keyName, matchType, caseSensitive = false) {
    let invalidResult = false;

    const elementValue = $element.val();
    const invalidValues = this.importer.RULES[ruleName].list;

    if (invalidValues && invalidValues.length !== 0) {
      invalidValues.every((invalidValue) => {
        let exactMatchType = invalidValue.type === STRINGS.EXACT_MATCH;
        let containsType = invalidValue.type === STRINGS.CONTAINS;

        if (matchType) {
          exactMatchType = matchType === STRINGS.EXACT_MATCH;
          containsType = matchType === STRINGS.CONTAINS;
        }

        if (exactMatchType) {
          invalidResult = (caseSensitive) ? elementValue === invalidValue[keyName] :
            elementValue.toUpperCase() === invalidValue[keyName].toUpperCase();
        } else if (containsType) {
          invalidResult = (caseSensitive) ? elementValue.indexOf(invalidValue[keyName]) >= 0 :
            elementValue.toUpperCase().indexOf(invalidValue[keyName].toUpperCase()) >= 0;
        }

        if (invalidResult) {
          invalidResult = { ruleName, ruleParams: [elementValue] };

          return false;
        }

        return true;
      });
    } else {
      if (window.console && console.warn) {
        console.warn(`Sparta Validation: ${ruleName} list empty.`);
      }

      return { ruleName, ruleParams: [elementValue] };
    }

    return invalidResult;
  }









  getValidResults($element, ruleName, keyName, caseSensitive = false) {
    let validResult = false;

    const elementValue = $element.val();
    const validValues = this.importer.RULES[ruleName].list;

    if (validValues && validValues.length !== 0) {
      validValues.every((validValue) => {
        if (caseSensitive) {
          validResult = elementValue === validValue[keyName];
        } else {
          validResult = elementValue.toUpperCase() === validValue[keyName].toUpperCase();
        }

        if (validResult) {
          return false;
        }

        return true;
      });
    } else if (window.console && console.warn) {
        console.warn(`Sparta Validation: ${ruleName} list empty.`);
    }

    if (validResult) {
      return true;
    }

    return { ruleName, ruleParams: [elementValue] };
  }
}

const AMLValidations = new AMLValidationRules();

export default AMLValidations;
